import { store } from 'redux/store';
import { getAuth } from 'redux/reducers/auth/selectors';
import { IAxiosRequestConfig } from './types';

// ==========================================:
export const onSuccess = (config: IAxiosRequestConfig) => {
	const requestConfig = config;
	const state = store.getState();
	const auth = getAuth(state);

	if (auth.accessToken) {
		requestConfig.headers = {
			Authorization: `${String(auth.accessToken)}`,
			Accept: 'text/plain',
			'Content-Type': 'application/json',
		};
	}

	return requestConfig;
};
